// mapDisplayConfig.ts — EV-356 / EV-360 (Patrick 2026-06-08)
// Shared accessor for the admin-controlled map config (admin.map_display_config,
// edited in the admin "Map Display" config screen). Fetched once on load + polled
// every 60s so admin changes reach the consumer map without a redeploy. Pure
// module singleton; callers read with a hardcoded fallback so the map always works
// even before the fetch resolves or if the endpoint is unreachable.

let _cfg: Record<string, any> = {};

function apiBase(): string {
  const env = (import.meta as any).env?.VITE_API_URL;
  return env ? String(env).replace(/\/$/, '') : '';
}

async function load(): Promise<void> {
  try {
    const r = await fetch(`${apiBase()}/api/map-display-config`);
    const d = await r.json();
    if (d && d.config && typeof d.config === 'object') _cfg = d.config;
  } catch { /* keep last/empty — callers fall back */ }
}

// Kick off immediately + poll (60s = the server cache TTL).
load();
if (typeof window !== 'undefined') setInterval(load, 60000);

/** Numeric config value with a fallback (handles string-encoded numbers). */
export function mapCfgNum(key: string, fallback: number): number {
  const v = _cfg[key];
  const n = typeof v === 'number' ? v : parseFloat(v);
  return Number.isFinite(n) ? n : fallback;
}

export function getMapCfg(): Record<string, any> {
  return _cfg;
}
